import React from 'react';
import { TableLoader } from './common/table-loader';
import { TabsLoader } from './common/tabs-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { EntitlementCardsLoader } from './common/entitlement-cards-loader';

export const EntitlementDetailsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hasLeftIcon hasSubheading />
      <EntitlementCardsLoader />
      <br />
      <TabsLoader tabsCount={7} />
      <br />
      <TableLoader hideSearchBar hideFilters hideActions />
      <br />
    </div>
  );
};
